import React from 'react';
import './Semaphore.css'
import { OverlayTrigger, Popover } from 'react-bootstrap';
import moment from 'moment';

export default function Semaphore(
    {
        prefixMessage = "Revisado el",
        caption,
        color,
        size,
        fontSize,
        lastUpdateDate,
        lastUpdatedBy,
        tooltipTitle,
        tooltipDescription = ""
    }) {
    const sizeDefault = "25px"
    const fontSizeDefault = "24px";

    const popover = (
        <Popover id="popover-semaphore">
            <Popover.Header as="h3">{tooltipTitle}</Popover.Header>
            <Popover.Body>
                {lastUpdateDate ? <div>{prefixMessage} <em>{moment(lastUpdateDate).format("DD/MM/yyyy HH:mm")}</em> por <em>{lastUpdatedBy}</em></div> : <div>Sin Actualización</div>}

                <div dangerouslySetInnerHTML={{ __html: tooltipDescription }}></div>
            </Popover.Body>
        </Popover>
    );

    return <>
        <OverlayTrigger trigger={['hover', 'focus']} placement="auto" overlay={popover}>
            <div className="semaforo-circle" style={{
                backgroundColor: color,
                width: size ? size : sizeDefault,
                height: size ? size : sizeDefault,
            }}>
                <span style={{ fontSize: fontSize ? fontSize : fontSizeDefault }}>{caption}</span>
            </div>
        </OverlayTrigger>
    </>;
}